export default __webpack_public_path__ + "assets/fb5e5bd4474debb0b9dc0270aef173f0.png";